module.exports = __webpack_public_path__ + "e1fb2d1d17011e8f4b13b3e5f578b83f.png";